// extracted by mini-css-extract-plugin
module.exports = {"sm":"_1f5a010","default":"_2803d80","lg":"_0a37de9"};